import { getS3SignedURL } from "@/actions/s3";

const computeSHA256 = async (file: File) => {
    const buffer = await file.arrayBuffer();
    const hashBuffer = await crypto.subtle.digest("SHA-256", buffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray
        .map((b) => b.toString(16).padStart(2, "0"))
        .join("");
    return hashHex;
};

export const handleS3ImageUploads = async (files: File[]) => {
    try {
        const fileUrls: string[] = [];

        for (let i = 0; i < files.length; i++) {
            const file = files[i];

            const signedURLResult = await getS3SignedURL({
                fileSize: file.size,
                fileType: file.type,
                checksum: await computeSHA256(file),
            });

            if (signedURLResult.error !== undefined) {
                throw new Error(signedURLResult.error);
            }

            const { url } = signedURLResult?.success as { url: string };

            await fetch(url, {
                method: "PUT",
                headers: {
                    "Content-Type": file.type,
                },
                body: file,
            });

            let fileUrl = url.split("?")[0];

            fileUrl = fileUrl.replace(
                "https://smartaurus.42aa8eb775fbcda9a2ca8a27e8584f80.r2.cloudflarestorage.com",
                "https://pub-df0973836b3146fba36b022d4b43f2eb.r2.dev"
            );

            fileUrls.push(fileUrl);
        }

        return fileUrls;
    } catch (error) {
        return []
    }
};
